import { useState } from "react";
import { Button, Modal } from "antd";
import "../styles.css";
import Wheel from "../../../assets/image/wheel.png";
import TROPHY from "../../../assets/image/trophy.gif";
import { API } from "../../../config/API";
import { POST } from "../../../utils/apirequest";
import { useParams } from "react-router-dom";

const SelectModal = (props: any) => {
  const { id, qid } = useParams();
  const [winner, setWinner] = useState<any>(null);
  const [drawn, setDrawn] = useState(false);
  const [start, setStart] = useState(false);
  const [loading, setLoading] = useState(false);

  const drawStart = () => {
    setWinner(null);
    setStart(true);
  };

  const handleDraw = async () => {
    try {
      setLoading(true);
      let obj = {
        type: "winner",
        masterId: id,
        itemId: qid,
      };
      let url = API.QUIZZ_SELECT_WINNER;
      const res: any = await POST(url, obj);
      if (res) {
        setWinner(res);
      } else {
        alert("No participants available for draw.");
      }
      setStart(false);
      setLoading(false);
    } catch (err) {
      console.log(err);
      alert("Error selecting winner. Please try again.");
      setLoading(false);
      setStart(false);
    }
  };

  return (
    <Modal
      title={null}
      open={props?.visible}
      onCancel={props?.onCancel}
      footer={false}
      width={500}
      maskStyle={{
        backdropFilter: "blur(6px)",
        WebkitBackdropFilter: "blur(6px)",
        backgroundColor: "rgba(0, 0, 0, 0.35)",
      }}
    >
      <div className="SelectModal-Box">
        {winner ? (
          <img src={TROPHY} className={"SelectModal-wheel1"} />
        ) : (
          <>
            <img
              src={Wheel}
              className={start ? "SelectModal-wheel2" : "SelectModal-wheel1"}
            />
            <Button
              danger
              size="large"
              block
              loading={loading}
              onClick={() => (start ? handleDraw() : drawStart())}
              disabled={drawn || loading}
            >
              {loading ? "Selecting winner..." : start ? "Stop" : "Draw Winner"}
            </Button>
          </>
        )}

        {winner && (
          <div
            style={{
              border: "1px solid grey",
              padding: 10,
              marginTop: 20,
              width: "100%",
            }}
          >
            <h4>{winner.winner_name}</h4>
            <p style={{ marginBottom: 0 }}>{winner.winner_phone}</p>
            <p style={{ marginBottom: 0 }}>{winner.winner_address}</p>
          </div>
        )}
      </div>
    </Modal>
  );
};

export default SelectModal;
